<template>
  <vue-final-modal v-model="state" classes="modal-container" content-class="modal-content" @before-close="closeDialog">
    <div class="modal-header justify-content-between p-4">
      <span class="modal__title text-white">Domains</span>
      <div>
        <button type="button" class="btn-close" aria-label="Close" @click="closeDialog()"></button>
      </div>
    </div>

      <div class="modal__body">
        <div class="modal__content mt-3 mb-4">
            <table class="table mt-3" v-if="!loading">
                <thead class="table-light">
                  <tr class="table-light text-default">
                    <th>Domain</th>
                    <th>IP Address</th>
                    <th>Private Key</th>
                    <th>Public Key</th>
                    <th>Selector</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody class="align-middle text-default" v-for="(item, index) in domains" :key="index">
                  <tr>
                      <td>{{ item.name }} </td>
                      <td>{{ item.ip_address }} </td>
                      <td>{{ shortenedName(item.private_key) }} </td>
                      <td>{{ shortenedName(item.public_key)}}</td>
                      <td>{{ item.selector }}</td>
                      <td>
                        <button type="button" class="btn btn-default btn-circle ms-1" ms-1 v-tooltip.top="'Edit Domain'" @click="setDomain(item)"><i class="far fa-edit"></i></button>
                        <button type="button" class="btn btn-default btn-circle-danger ms-1" ms-1 v-tooltip.top="'Delete Domain'"><i class="fas fa-trash" @click="deleteDomain(item.ID)"></i></button>
                      </td>
                  </tr>
                </tbody>
            </table>

            <div v-if="loading" class="text-center align-middle">
                <img src="@/assets/img/loading.svg">
            </div>

            <div class="modal__input-fields mt-4">
              <span class="modal__title text-default">{{ buttonSave == "Save" ? "Add Domain" : "Update Domain" }}</span>
              <input v-model="editedItem.name" class="form-control mb-2" placeholder="Domain" @blur="v$.editedItem.name.$touch()">
              <div class="text-danger" v-for="error of v$.editedItem.name.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>

              <input v-model="editedItem.ip_address" class="form-control mb-2" placeholder="IP Address" @blur="v$.editedItem.ip_address.$touch()">
              <div class="text-danger" v-for="error of v$.editedItem.ip_address.$errors" :key="error.$uid">
                <div class="form-text text-danger">{{ error.$message }}</div>
              </div>
              <input v-model="editedItem.private_key" class="form-control mb-2" placeholder="Private Key">
              <input v-model="editedItem.public_key" class="form-control mb-2" placeholder="Public Key">
              <input v-model="editedItem.selector" class="form-control mb-2" placeholder="Selector">
              <div class="col-12 mb-5">
                <div class="text-center p-1">
                  <button type="button" class="btn btn-outline-primary ms-3 col-10" style="padding-right:19px" @click="addNewDomain" >{{ buttonSave }}</button>
                </div>
                <div class="text-center p-1">
                  <button type="button" class="btn btn-outline-clear ms-3 col-10" @click="clear">Clear</button>
                </div>
              </div>

            </div>
        </div>
      </div>
    </vue-final-modal>
</template>

<script>

import { useVuelidate } from '@vuelidate/core'
import { required, ipAddress } from '@vuelidate/validators'

export default {
  name: "DeleteForm",

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },

  setup () {
      return { v$: useVuelidate() }
    },

    validations () {
      return {
        editedItem: {
          name: {required},
          ip_address: {ipAddress}
        },
      }
    },

  data() {
    return {
      state: this.dialog,
      buttonSave: 'Save',
      loading: true,
      editedItem: {
        name: "",
        private_key: "",
        public_key: "",
        selector: "",
        ip_address: "",
      },
      domains: [],
      orgID: this.$helper.setOrganisationID(),
    };
  },

  async mounted(){
    await this.getData();
  },

  watch: {
    dialog(newVal) {
      this.state = newVal;
    },

    organisation(){
      if (this.$store.state.auth.accessToken == null) return
      this.orgID = this.$store.state.user.organisation.id
      this.init();
    }
  },

  methods: {
    getData() {
      this.$axios.get('/orgadmin/phishing-domain/'+ this.orgID)
      .then((response) => {
          if (response.data.success){
            this.domains = response.data.domains;
          } else {
            this.$toast.error(response.data.message)
          }
        this.loading = false;
      })
      .catch()
    },


    addNewDomain() {
      //validate inputs
      if (this.v$.editedItem.name.$invalid || this.v$.editedItem.ip_address.$invalid) return

      //change state
      this.loading = true;

      //check state if saving or not, save or update depending on state
      if (this.buttonSave == 'Save'){
        this.$axios.post('/supadmin/phishing-domain', this.editedItem)
        .then((response) => {
          if (response.data.success){
            this.$toast.success(response.data.message)
            this.getData();
            this.saving = false;
            this.clearFields();
          }
          else{
            this.$toast.error(response.data.message)
            this.saving = false;
          }

        })
        .catch()
      } else {
        this.$axios.put('/supadmin/phishing-domain/' + this.editedItem.ID, this.editedItem)
        .then((response) => {
          if (response.data.success){
            this.getData();
            this.$toast.success(response.data.message)
            this.loading = false;
            this.clearFields();
          }
          else{
            this.$toast.error(response.data.message)
            this.loading = false;
          }
        })
        .catch()
      }
      this.v$.$reset();
    },

    closeDialog() {
      this.$emit("close");
      this.state = false;
    },

    clearFields() {
      this.editedItem.ID = 0
      this.editedItem.name = "";
      this.editedItem.ip_address = "";
      this.editedItem.private_key = "";
      this.editedItem.public_key = "";
      this.editedItem.selector = "";
      this.buttonSave = "Save";
    },

    setDomain(item){
      this.editedItem.ID = item.ID
      this.editedItem.name = item.name;
      this.editedItem.private_key = item.private_key;
      this.editedItem.public_key = item.public_key
      this.editedItem.selector = item.selector
      this.editedItem.ip_address = item.ip_address;
      this.buttonSave = "Update";
    },

    clear() {
      this.editedItem = {};
      this.buttonSave = "Save"
    },

    submit(){

    },

    deleteDomain(id){
      if(confirm("Do you really want to delete this domain?")) {
        this.$axios.delete('/supadmin/phishing-domain/' + id)
        .then((response) => {
            if (response.data.success){
                this.$toast.success(response.data.message)
                this.getData();
            } else {
                this.$toast.error(response.data.message)
            }
        })
        .catch()
      }
    },

    shortenedName(item) {
      if (item)
        return item.slice(0, 15) + '...';

      return '';
    }

  },
};
</script>

<style scoped>
:deep(.modal-content) {
  width: 50% !important;
}

:deep(.modal-header) {
	height: 0px;
	padding: 1rem;
}
</style>
